import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://glet_d62128ac066357ca4aed2f941ae7d871@observe.gitlab.com:443/errortracking/api/v1/projects/65352549",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});